import config from "@/config/config";
import useCurrencyStore, { Currencies } from "@/store/currencyStore";
import { defaultCurrencies } from "@/utils/currency";
import { QueryOptions, useQuery } from "@tanstack/react-query";
import axios from "axios";
import { getClientIp } from "./client-ip";

type UserLocaleType = {
  localeCurrency: string;
  conversionRate?: number;
};

let currencyManuallySet = false;

export const markCurrencyManuallySet = () => {
  currencyManuallySet = true;
};

const getLocaleCurrency = async (): Promise<UserLocaleType> => {
  const {
    addCurrency,
    setConversionRate,
    setCurrency,
    conversionRate,
    currency: currentCurrency,
  } = useCurrencyStore.getState();
  try {
    const { ip } = await getClientIp();
    if (!ip) {
      throw Error("Couldn't retrieve client IP.");
    }
    const locale = await axios.get(`payment/ip/${ip}`, {
      baseURL: config.baseURL,
    });
    const { currency, country } = locale.data;
    const isFromEgypt = country?.toLowerCase().includes("egypt");
    const localeCurrency = isFromEgypt ? Currencies.EGP : currency;
    const conversion_response = await axios.get(`payment/conversion-rate/${localeCurrency}`, {
      baseURL: config.baseURL,
    });
    const { converted_amount } = conversion_response.data;
    if (converted_amount && localeCurrency) {
      addCurrency(localeCurrency);
      setConversionRate(Number(converted_amount));
      if (
        !currencyManuallySet &&
        (isFromEgypt ||
          !conversionRate ||
          (!defaultCurrencies.includes(currentCurrency) && currentCurrency !== localeCurrency))
      ) {
        setCurrency(localeCurrency);
      }
    }
    return {
      localeCurrency,
      conversionRate: Number(converted_amount),
    };
  } catch (err) {
    if (!currencyManuallySet) {
      setCurrency(Currencies.USD);
      setConversionRate(1);
    }
    return {
      localeCurrency: Currencies.USD,
      conversionRate: 1,
    };
  }
};

export const useGetLocaleCurrency = (options?: QueryOptions) => {
  return useQuery<unknown, Error, UserLocaleType>({
    queryKey: ["user-locale"],
    queryFn: getLocaleCurrency,
    ...options,
  });
};
